<template>
	<div>	
		<snow></snow>	
		<!-- <pm-navegar-pagina-vieja ></pm-navegar-pagina-vieja> -->
		<pm-header
			:notificaciones="notificaciones"
			:notificacionesPendientes="notificacionesPendientes"
			:items="articulosDescripcion"
			:totalCarrito="totalCarrito"
			:animarCarrito="animarCarrito"
			@actualizarNotificaciones="actualizarNotificaciones"
			@buscar="buscar"
			@enviarInicio="enviarInicio"
			@carritoCompras="carritoCompras"
			@togleMenu="togleMenu"
		></pm-header>
		<pm-menu-movil class="mt-5"
			:inicioClientes="inicioClientes"
			:esBuenFin="esBuenFin"
			:busquedaGeneral="busquedaGeneral"
			@buscar="buscar"
			></pm-menu-movil>
		<pm-sidebar class=""
			:animarCarrito="animarCarrito"
			:totalCarrito="totalCarrito"
			:totalNuevos="totalNuevos"
			:totalOfertas="totalOfertas"
			:totalRemates="totalRemates"
			:totalBuenFin="totalBuenFin"
			:esBuenFin="esBuenFin"
			:busquedaGeneral="busquedaGeneral"
			:inicioClientes="inicioClientes"
			:sideBarValue="sideBarValue"
			:sideBarTime="sideBarTime"
			:opcion="opcion"
			@buscar="buscar"
		>
			<template slot="contenido">				
				<router-view
					:data="data"
					:textoBusqueda="textoBusqueda"
					@actualizarCantidadNuevos="actualizarCantidadNuevos"
					@actualizarCantidadOfertas="actualizarCantidadOfertas"
					@actualizarCantidadRemates="actualizarCantidadRemates"
					@actualizarCantidadBuenFin="actualizarCantidadBuenFin"
					@actualizarNotificaciones="actualizarNotificaciones"
					@actualizarTotalCarrito="actualizarTotalCarrito"
					@alertaActualizar="alertaActualizar"
					@alertaAgregar="alertaAgregar"
					@alertaEliminar="alertaEliminar"
					@sideBarSelect="sideBarSelect"
					@togleMenu="togleMenu"
					class="mb-5"
				></router-view>
			</template>
		</pm-sidebar>		
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import PmHeader from "@/components/clientes/Header.vue"
	import PmSidebar from "@/components/clientes/Sidebar.vue"
	import PmMenuMovil from "@/components/clientes/MenuMobile.vue"
	import servicio from "@/services/servicio-catalogo-general"
	import snow from '@/components/clientes/Snow.vue'
	// import PmNavegarPaginaVieja from '@/components/NavegarPaginaVieja'

	export default {
		name: "Layout",
		data() {
			return {
				totalCarrito: 0,
				totalNuevos: 0,
				totalOfertas: 0,
				totalRemates: 0,
				totalBuenFin: 0,
				esBuenFin: false,
				textoBusqueda: "",
				busquedaAvanzada: false,
				data: {},
				notificaciones: [],
				articulosDescripcion: [],
				notificacionesPendientes: false,
				animarCarrito: false,
				busquedaGeneral: false,
				inicioClientes: false,
				sideBarTime: 0,
				sideBarValue:0,
				opcion:0
			}
		},
		mounted() {
			//this.ocultarChat()
			this.consultarDescripcionArticulos()
			this.revisarEsBuenFin()

			this.$root.$on('Layout-Buscar', ( parametros) => {
				this.buscar(parametros)
			})
		},		
		components: {
			PmHeader,
			PmMenuMovil,
			PmSidebar,
			snow
			// PmNavegarPaginaVieja
		},
		computed:{
			...mapState(['busqueda','loading']),
		},		
		methods: {
			togleMenu(opcion){
				this.opcion = opcion
				this.$nextTick(()=>{
					this.opcion = 0
				})
			},
			carritoCompras(){
				try {
					this.togleMenu(4)
					this.$router
						.push({ path: `/clientes/carrito` })
						.catch((err) => err)
				} catch {
					console.log("Error")
				}
			},
			consultarDescripcionArticulos(){
				servicio.consultarDescripcionArticulos(0)
					.then( r => {
						this.articulosDescripcion = r.data
						//console.log('consultarDescripcionArticulos', r)
					})
					.catch(error => {
						console.log('consultarDescripcionArticulos', error)
					}) 
			},
			revisarEsBuenFin(){
				servicio.revisarEsBuenFin()
					.then(r => {
						this.esBuenFin = r.value
					})
					.catch(error => {
						console.log("revisarEsBuenFin", error)
					})
			},

			...mapActions(['buscarProductos', 'resetParametros','sustitutos','resetItemSustitutos']),
			enviarInicio(){
				this.inicioClientes = true
				this.$nextTick(()=> this.inicioClientes = false)
			},
			buscar(parametros) {

				if(this.loading){
					return
				}
				this.resetParametros()
				this.resetItemSustitutos()
				this.busquedaGeneral = true
				this.busqueda.parametros.buscar = parametros.buscar
				if(this.$route.name == 'busqueda-general'){
					this.$router.replace({
						query: this.busqueda.parametros
					})
					.then(async () => {
						await this.buscarProductos()
						console.log("itemSeleccionadoBuscador", this.busqueda.itemSeleccionadoBuscador)
						if(this.busqueda.itemSeleccionadoBuscador){
							await this.sustitutos()
						}
						this.busquedaGeneral = false
					})
					.catch(()=>{})
				}
				else{
					this.$router.push({
						name: 'busqueda-general',
						query: this.busqueda.parametros
					})
					.then(() => {
						this.buscarProductos()
						this.busquedaGeneral = false
					})
					.catch(()=>{})
				}				
			},

			actualizarTotalCarrito(total) {
				this.totalCarrito = total
				//console.log('this.totalCarrito: ', this.totalCarrito)
				//console.log("actualizo", this.animarCarrito)
			},
			actualizarNotificaciones(notificaciones) {
				if(!notificaciones)
					return

				this.notificaciones = notificaciones.data
				this.notificaciones.forEach(n => {
					if (n.visto == false) {
						this.notificacionesPendientes = true
						return
					} else {
						this.notificacionesPendientes = false
					}
				})
			},
			actualizarCantidadNuevos(total) {
				this.totalNuevos = total
			},
			actualizarCantidadOfertas(total) {
				this.totalOfertas = total
			},
			actualizarCantidadRemates(total) {
				this.totalRemates = total
			},
			actualizarCantidadBuenFin(total){
				this.totalBuenFin = total
			},
			// busquedaCatalogoGeneral(parametros) {
			// 	//console.log("parametros 1:",parametros)
			// 	//this.$router.push({name: 'catalogo-general', params: parametros })
				
			// 	//console.log(parametros)

			// 	this.$loading(true)
			// 	this.busquedaGeneral = true

			// 	// let p = {
			// 	// 	buscar: "",
			// 	// 	orden: 1,
			// 	// 	codClasificacion: 0,
			// 	// 	codFormaFarmaceutica: 0,
			// 	// 	tipoFormula: "",
			// 	// 	codFormula: 0,
			// 	// 	contenidoVenta: 0,
			// 	// 	pagina: 1,
			// 	// }

			// 	parametros.buscar = this.textoBusqueda
			// 	parametros.busquedaAvanzada = this.busquedaAvanzada
			// 	parametros.orden = parametros.orden == null ? 1 : parametros.orden
			// 	parametros.codClasificacion = parametros.codClasificacion == null ? 0 : parametros.codClasificacion
			// 	parametros.codFormaFarmaceutica = parametros.codFormaFarmaceutica == null ? 0 : parametros.codFormaFarmaceutica
			// 	parametros.codFormula = parametros.codFormula == null ?  0 : parametros.codFormula
			// 	parametros.contenidoVenta = parametros.contenidoVenta == null ? 0 : parametros.contenidoVenta

			// 	parametros.buscar =
			// 		parametros.buscar == "" ? "__TODO__" : parametros.buscar

			// 	parametros.tipoFormula =
			// 		parametros.tipoFormula == "" || parametros.tipoFormula == null
			// 			? "A"
			// 			: parametros.tipoFormula

			// 	parametros.pagina =
			// 		parametros.pagina == null ||
			// 		parametros.pagina == "" ||
			// 		parametros.pagina == 0
			// 			? 1
			// 			: parametros.pagina
			// 	//console.log('parametros', parametros)
			// 	this.$router.push({ name: "catalogo-general", params: parametros })
			// 	.catch(()=>{})
				
			// 	// this.$router
			// 	// 	.replace({ name: "catalogo-general", params: parametros })
			// 	// 	.catch(() => {})

			// 	this.data = { totalPaginas: 0 }

			// 	servicio.buscar(parametros).then(r => {
			// 		this.data = r.data
			// 		this.$loading(false)
			// 		this.busquedaGeneral = false
			// 	})
			// },
			alertaAgregar() {
				// this.$bvToast.toast(`Se agregó un producto del carrito`, {
				// 	title: "Carrito de compras",
				// 	autoHideDelay: 5000,
				// 	appendToast: false,
				// 	variant: "success",
				// 	toaster: "b-toaster-bottom-left"
				// })
				this.animaCarrito()
			},
			alertaEliminar() {
				// this.$bvToast.toast(`Se eliminó un producto del carrito`, {
				// 	title: "Carrito de compras",
				// 	autoHideDelay: 5000,
				// 	appendToast: false,
				// 	variant: "danger",
				// 	toaster: "b-toaster-bottom-left"
				// })
				this.animaCarrito()
			},
			alertaActualizar() {
				// this.$bvToast.toast(`Se actualizó el carrito exitosamente`, {
				// 	title: "Carrito de compras",
				// 	autoHideDelay: 5000,
				// 	appendToast: false,
				// 	variant: "info",
				// 	toaster: "b-toaster-bottom-left"
				// })
				this.animaCarrito()
			},
			animaCarrito() {
				this.animarCarrito = true
				setTimeout(() => {
					this.animarCarrito = false
				}, 2000)
			},
			sideBarSelect(tiempo, valor){
				this.sideBarValue = valor;
				this.sideBarTime = tiempo;
			}
		}
	}
</script>
<style scoped></style>
